<script setup>
import { ref, watch } from 'vue'
import PlayerPosition from '../player/PlayerPosition.vue';

const emit = defineEmits(['save'])
const { player, icon, isEditing, roster } = defineProps({
    player: {
        type: [Object, null],
    },
    icon: String,
    isEditing: {
        type: Boolean,
        default: false,
    },
    roster: {
        type: Array,
        default: () => [],
    }
})
const playerId = ref(null)

watch(() => isEditing, () => {
    if (isEditing) {
        return;
    }
    emit('save', playerId.value, icon)
})
watch(() => player, () => {
    playerId.value = player && player.id ? player.id : null;
})
</script>

<template>
    <div v-if="isEditing">
        <select v-model="playerId" class="form-select form-control-dark form-select-sm">
            <option :value="null" :disabled="true">Выберите игрока</option>
            <option v-for="item in roster" :value="item.id" :key="item.id">{{ item.tag.tag }}</option>
        </select>
    </div>
    <template v-else>
        <span v-if="player" :class="['fi', 'fi-' + player.country_id, 'fis', 'rounded-circle', 'ms-auto']"></span>
        <div class="text-nowrap">
            <a v-if="player" :href="player.link" class="text-decoration-none">{{ player.tag.tag }}</a>
            <span v-else class="text-muted">N/A</span>
        </div>
    </template>
    <player-position :icon="icon" :alt="icon"/>
</template>
